import React, {useState, useEffect} from 'react'
import { useParams} from 'react-router-dom'
import './cardcss.css'
export const IngresoCard = ({
	fontColor,
	bgColor,
	// error = null,
	// error1 = null,
	// error2 = null,
	// error3 = null,
	sku,
	descripcion, 
	roi,
	precioLista,
	mgIncrementalPorcentaje,
	mgIncrementalDinero,
	mecanica,
	descuento,
	uplift,
	mensaje,
	simulado,
	item, upliftPorcentual
	, margenPromocion, margenComercial, margenComercialIncremental, margenComercialIncrementalPorcentaje
	, estadoProducto = null, 
	setModalProduct, 
	setDataProduct
}) => {
	const [error, setError] = useState(false);
	const [error1, setError1] = useState(false);
	const [error2, setError2] = useState(false);
	const [error3, setError3] = useState(false);
	const { idPromocion , estadoPromocion} = useParams()
	const [estadoActual, setEstadoActual] = useState(estadoProducto && estadoProducto.accion)
	const [productos, setProductos] = useState([]);
	const [clickHere, setClickHere] = useState(false)

	console.log("Contenido Item::::: ");
	console.log(item)
	console.log(estadoProducto)

	useEffect(() => {
		if(simulado === 0 || item.bajo_costo === -1){
			setError(true);
			setError3(true);
		}

		if(item.faltan_datos === 1){
			setError(true);
			setError2(true);
		}

		if(item.bajo_costo === 1){
			setError(true);
			setError1(true);
		}
	}, []);

	const actualizarProductos = () => {
		const gestionProductos = localStorage.getItem('gestionProductos');
		// alert(gestionProductos)
		if (gestionProductos) {
		  setProductos(JSON.parse(gestionProductos));
		} else {
		  setProductos([]);
		}
	};

	const productoExiste = (idProducto_) => {
		return productos.filter(producto => producto.id_producto === idProducto_)[0];
	}

	useEffect(() => {
		// Inicialmente obtener los productos
		// alert("nocorre")
		actualizarProductos();
		const producto = productoExiste(item.id_producto);
		console.log("Producto:::::::::::::::::::::Seleccionado A Cambiar:::::::")
		console.log(producto)
		if (producto && !clickHere) {
			if (producto.accion === 'aprobado') {
				// alert("aprobado")
				setEstadoActual("aprobado")
			} else if (producto.accion === 'rechazado') {
				// alert("rechazado")
				setEstadoActual("rechazado")
			} /* else if (producto.accion === 'cambio') {
				setEstadoProducto_(-1)
			} */
		}
		setClickHere(false)
		window.addEventListener("storage", actualizarProductos);
		return () => {
			// Remove the handler when the component unmounts
			window.removeEventListener("storage", actualizarProductos);
		};
	  }, [localStorage.getItem('gestionProductos')]);

	const gestionarProducto = (e, estado) => {
		const prevGestionProductos = localStorage.getItem('gestionProductos');
		let gestionProductos = prevGestionProductos ? JSON.parse(prevGestionProductos) : [];
		gestionProductos = gestionProductos.filter(producto => producto.id_producto !== item.id_producto);

		gestionProductos.push({
							'id_promocion': idPromocion,
							'id_producto': item.id_producto,// keyId,
							'accion': estado
						});

						localStorage.setItem('gestionProductos', JSON.stringify(gestionProductos));
						window.dispatchEvent(new Event("storage"));
	}

	return (
		<div className='IngresoCardWrapper'>
		
		{((estadoPromocion === '5' || estadoPromocion === '7')
				&& (
						localStorage.getItem('rol') === 'ADMIN' ||
						localStorage.getItem('rol') === 'SUPER ADMIN' 
				)
			)  && ( <>
			<div className={(estadoActual === "aprobado" || (estadoProducto && estadoProducto.accion==="aprobado")) ? 'pen-wrapper2-aprobar-activo' : 'pen-wrapper2-aprobar'}>
				<svg
					width='36'
					height='36'
					viewBox='0 0 36 36'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					onClick={(e) => {
						setClickHere(true)
						if(estadoProducto){estadoProducto.accion = "aprobado"}
						setEstadoActual("aprobado")
						gestionarProducto(e, 'aprobado')
						
					}}
				>
					<path d='M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24H0V8Z' />
						<mask
							id='mask0_640_389992'
							maskUnits='userSpaceOnUse'
							x='8'
							y='4'
							width='16'
							height='16'
						>
							<rect x='8' y='4' width='16' height='16' fill='#D9D9D9' />
						</mask>
						<g mask='url(#mask0_640_389992)' >
							<path
								d='M12 18L8 14L9.5 12.5L12 15L18.5 8.5L20 10L12 18Z'
								fill='#ADADAD'
							/>
						</g>
				</svg>
			</div>
			<div className={(estadoActual === "rechazado" || (estadoProducto && estadoProducto.accion==="rechazado")) 
							? 'pen-wrapper3-rechazar-activo' : 'pen-wrapper3-rechazar'}>
				<svg
					width='36'
					height='36'
					viewBox='0 0 36 36'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					title="Rechazar producto"
					onClick={(e) => {
						setClickHere(true)
						if(estadoProducto){estadoProducto.accion = "rechazado"}
						setEstadoActual("rechazado")
						gestionarProducto(e, 'rechazado')
						}
					}
				>
					<path d='M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24H0V8Z' />
						<mask
							id='mask0_640_389992'
							maskUnits='userSpaceOnUse'
							x='8'
							y='4'
							width='16'
							height='16'
						>
							<rect x='8' y='4' width='16' height='16' fill='#D9D9D9' />
						</mask>
						<g mask='url(#mask0_640_389992)' >
							<path
								d='M15.9999 13.0666L12.7999 16.2666C12.6555 16.411 12.4777 16.4833 12.2666 16.4833C12.0555 16.4833 11.8777 16.411 11.7333 16.2666C11.5888 16.1222 11.5166 15.9444 11.5166 15.7333C11.5166 15.5222 11.5888 15.3444 11.7333 15.1999L14.9333 11.9999L11.7333 8.79993C11.5888 8.65549 11.5166 8.47771 11.5166 8.2666C11.5166 8.05549 11.5888 7.87771 11.7333 7.73327C11.8777 7.58882 12.0555 7.5166 12.2666 7.5166C12.4777 7.5166 12.6555 7.58882 12.7999 7.73327L15.9999 10.9333L19.1999 7.73327C19.3444 7.58882 19.5222 7.5166 19.7333 7.5166C19.9444 7.5166 20.1222 7.58882 20.2666 7.73327C20.411 7.87771 20.4833 8.05549 20.4833 8.2666C20.4833 8.47771 20.411 8.65549 20.2666 8.79993L17.0666 11.9999L20.2666 15.1999C20.411 15.3444 20.4833 15.5222 20.4833 15.7333C20.4833 15.9444 20.411 16.1222 20.2666 16.2666C20.1222 16.411 19.9444 16.4833 19.7333 16.4833C19.5222 16.4833 19.3444 16.411 19.1999 16.2666L15.9999 13.0666Z'
								fill='#ADADAD'
							/>
						</g>
				</svg>
				
			</div>
			</>
			)}
		{ /*
			<div className='editor-hover'>
				<p>Aprobar Producto</p>

				<svg
					width='8'
					height='16'
					viewBox='0 0 8 16'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M7.76471 7.28292C8.07843 7.60162 8.07843 8.39838 7.76471 8.71708L0.705882 15.8878C0.392156 16.2065 -6.90997e-07 15.8082 -6.63135e-07 15.1708L-3.62473e-08 0.829242C-8.38568e-09 0.191842 0.392157 -0.206533 0.705883 0.112167L7.76471 7.28292Z'
						fill='#3676F5'
					/>
				</svg>
			</div>
			*/ }
	 
			<div
				className='IngresoCard'
				onMouseEnter={(e) => {
					if (e.target.classList[0] === 'IngresoCard') {
						e.target.style.borderColor = fontColor
					} else {
						e.target.closest('.IngresoCard').style.borderColor = fontColor
					}
				}}
				onMouseLeave={(e) => {
					if (e.target.classList[0] === 'IngresoCard') {
						e.target.style.borderColor = 'transparent'
					} else {
						e.target.closest('.IngresoCard').style.borderColor = 'transparent'
					}
				}}
			>
				<span className="tooltiptext2">{item.tipo_promocion.split('-')[0][0]}{item.tipo_promocion.split('-')[1][0]}</span>
				<div className='row-wrapper'>


					

			
					<div className='col'>
					
						<div>
							<a style={{cursor: "pointer"}}
								onClick={(e) => {
									setDataProduct({
										"codigo_producto": sku,
										"descripcion" : descripcion,
									})
									setModalProduct(true)
								}}
							>{sku}</a>
						</div>
						<div>
							<p>{descripcion}<br></br>
							
							</p>
							
						</div>
						<div>
							<p>
								List Price <span>{precioLista}</span>
							</p>
						</div>
						<div>
							<p>
								% Discount. <span>{descuento}%</span>
							</p>
						</div>
						<div>
							<p>
								Mechanics <span>{mecanica}</span>
							</p>
						</div>
					</div>
					<div
						className='col'
						style={{background: bgColor, borderColor: fontColor}}
					>
						<div style={{borderColor: fontColor}}>
								<div className='error-arrow-wrapper'>

								
									{error1 && (
										<>
											<div className='error-arrow arrow-first'>
												<svg
													width='11'
													height='7'
													viewBox='0 0 11 7'
													fill='none'
													xmlns='http://www.w3.org/2000/svg'
												>
													<path
														d='M7.45045 6.07501C7.29212 6.07501 7.15662 6.01868 7.04395 5.90601C6.93162 5.79368 6.87545 5.65835 6.87545 5.50001C6.87545 5.34168 6.93162 5.20635 7.04395 5.09401C7.15662 4.98135 7.29212 4.92501 7.45045 4.92501H8.15045L5.71295 2.52501L4.11295 4.12501C4.06295 4.17501 4.00262 4.21451 3.93195 4.24351C3.86095 4.27285 3.78795 4.28751 3.71295 4.28751C3.63795 4.28751 3.56712 4.27285 3.50045 4.24351C3.43379 4.21451 3.37129 4.17501 3.31295 4.12501L0.300452 1.08751C0.200452 0.979179 0.150452 0.850012 0.150452 0.700012C0.150452 0.550012 0.204618 0.416679 0.312952 0.300012C0.421285 0.191679 0.554618 0.137512 0.712952 0.137512C0.871285 0.137512 1.00462 0.191679 1.11295 0.300012L3.71295 2.90001L5.31295 1.30001C5.37129 1.24168 5.43379 1.20001 5.50045 1.17501C5.56712 1.15001 5.63795 1.13751 5.71295 1.13751C5.78795 1.13751 5.85879 1.15001 5.92545 1.17501C5.99212 1.20001 6.05462 1.24168 6.11295 1.30001L8.95045 4.13751V3.43751C8.95045 3.27918 9.00462 3.14368 9.11295 3.03101C9.22129 2.91868 9.35462 2.86251 9.51295 2.86251C9.67129 2.86251 9.80662 2.91868 9.91895 3.03101C10.0316 3.14368 10.088 3.27918 10.088 3.43751V5.50001C10.088 5.65835 10.0316 5.79368 9.91895 5.90601C9.80662 6.01868 9.67129 6.07501 9.51295 6.07501H7.45045Z'
														fill='#FF5334'
													/>
												</svg>

												<div className='error-hover-state'>
													<p>Low cost</p>
													<svg
														width='17'
														height='8'
														viewBox='0 0 17 8'
														fill='none'
														xmlns='http://www.w3.org/2000/svg'
													>
														<path
															d='M8.86632 7.40838C8.83899 7.43528 8.71392 7.5 8.5 7.5C8.28608 7.5 8.16101 7.43528 8.13369 7.40838L1.13583 0.519758C1.19042 0.507766 1.25531 0.500001 1.32924 0.500001L15.6708 0.5C15.7447 0.5 15.8096 0.507766 15.8642 0.519757L8.86632 7.40838Z'
															fill='#FF5334'
															stroke='#FF5334'
															strokeMiterlimit='1.78922'
														/>
													</svg>
												</div>
											</div>
										</>
									)}

									{error2 && (
										<>
											<div className='error-arrow'>
												<svg
													width='12'
													height='12'
													viewBox='0 0 12 12'
													fill='none'
													xmlns='http://www.w3.org/2000/svg'
												>
													<g clipPath='url(#clip0_491_388881)'>
														<mask
															id='mask0_491_388881'
															maskUnits='userSpaceOnUse'
															x='0'
															y='0'
															width='12'
															height='12'
														>
															<rect width='12' height='12' fill='#D9D9D9' />
														</mask>
														<g mask='url(#mask0_491_388881)'>
															<path
																d='M5.99978 8.55001C6.15811 8.55001 6.28945 8.49801 6.39378 8.39401C6.49778 8.28968 6.54978 8.15834 6.54978 8.00001V6.03751C6.54978 5.87918 6.49778 5.75001 6.39378 5.65001C6.28945 5.55001 6.15811 5.50001 5.99978 5.50001C5.84145 5.50001 5.71028 5.55201 5.60628 5.65601C5.50195 5.76034 5.44978 5.89168 5.44978 6.05001V8.01251C5.44978 8.16251 5.50195 8.28968 5.60628 8.39401C5.71028 8.49801 5.84145 8.55001 5.99978 8.55001ZM5.99978 4.56251C6.15811 4.56251 6.29145 4.50834 6.39978 4.40001C6.50811 4.29168 6.56228 4.15834 6.56228 4.00001C6.56228 3.84168 6.50811 3.70834 6.39978 3.60001C6.29145 3.49168 6.15811 3.43751 5.99978 3.43751C5.84145 3.43751 5.70811 3.49168 5.59978 3.60001C5.49145 3.70834 5.43728 3.84168 5.43728 4.00001C5.43728 4.15834 5.49145 4.29168 5.59978 4.40001C5.70811 4.50834 5.84145 4.56251 5.99978 4.56251ZM5.99978 11.1C5.29145 11.1 4.62678 10.9667 4.00578 10.7C3.38511 10.4333 2.84561 10.0708 2.38728 9.61251C1.92895 9.15418 1.56645 8.61468 1.29978 7.99401C1.03311 7.37301 0.89978 6.70834 0.89978 6.00001C0.89978 5.29168 1.03311 4.62701 1.29978 4.00601C1.56645 3.38534 1.92895 2.84584 2.38728 2.38751C2.84561 1.92918 3.38511 1.56668 4.00578 1.30001C4.62678 1.03334 5.29145 0.900009 5.99978 0.900009C6.70811 0.900009 7.37278 1.03334 7.99378 1.30001C8.61445 1.56668 9.15395 1.92918 9.61228 2.38751C10.0706 2.84584 10.4331 3.38534 10.6998 4.00601C10.9664 4.62701 11.0998 5.29168 11.0998 6.00001C11.0998 6.70834 10.9664 7.37301 10.6998 7.99401C10.4331 8.61468 10.0706 9.15418 9.61228 9.61251C9.15395 10.0708 8.61445 10.4333 7.99378 10.7C7.37278 10.9667 6.70811 11.1 5.99978 11.1ZM5.99978 9.96251C7.09978 9.96251 8.03528 9.57718 8.80628 8.80651C9.57695 8.03551 9.96228 7.10001 9.96228 6.00001C9.96228 4.90001 9.57695 3.96451 8.80628 3.19351C8.03528 2.42284 7.09978 2.03751 5.99978 2.03751C4.89978 2.03751 3.96445 2.42284 3.19378 3.19351C2.42278 3.96451 2.03728 4.90001 2.03728 6.00001C2.03728 7.10001 2.42278 8.03551 3.19378 8.80651C3.96445 9.57718 4.89978 9.96251 5.99978 9.96251Z'
																fill='#FF5334'
															/>
														</g>
													</g>
													<defs>
														<clipPath id='clip0_491_388881'>
															<rect width='12' height='12' fill='white' />
														</clipPath>
													</defs>
												</svg>
												<div className='error-hover-state'
												>
													<p>Missing Data</p>
													<svg
														width='17'
														height='8'
														viewBox='0 0 17 8'
														fill='none'
														xmlns='http://www.w3.org/2000/svg'
													>
														<path
															d='M8.86632 7.40838C8.83899 7.43528 8.71392 7.5 8.5 7.5C8.28608 7.5 8.16101 7.43528 8.13369 7.40838L1.13583 0.519758C1.19042 0.507766 1.25531 0.500001 1.32924 0.500001L15.6708 0.5C15.7447 0.5 15.8096 0.507766 15.8642 0.519757L8.86632 7.40838Z'
															fill='#FF5334'
															stroke='#FF5334'
															strokeMiterlimit='1.78922'
														/>
													</svg>
												</div>
											</div>
										</>
									)}
									{error3 && (
										<> 
											<div className='error-arrow '>
												
												<svg
													width='12'
													height='12'
													viewBox='0 0 12 12'
													fill='none'
													xmlns='http://www.w3.org/2000/svg'
												>
													<g clipPath='url(#clip0_491_128728)'>
														<mask
															id='mask0_491_128728'
															maskUnits='userSpaceOnUse'
															x='0'
															y='0'
															width='12'
															height='12'
														>
															<rect width='12' height='12' fill='#D9D9D9' />
														</mask>
														<g mask='url(#mask0_491_128728)'>
															<path
																d='M2.53752 11.1C2.22086 11.1 1.95219 10.9897 1.73152 10.769C1.51052 10.548 1.40002 10.2792 1.40002 9.96249V3.03749C1.40002 2.72083 1.51052 2.45199 1.73152 2.23099C1.95219 2.01033 2.22086 1.89999 2.53752 1.89999H3.00002V1.43749C3.00002 1.28749 3.05202 1.16033 3.15602 1.05599C3.26036 0.951994 3.38752 0.899994 3.53752 0.899994C3.68752 0.899994 3.81469 0.951994 3.91902 1.05599C4.02302 1.16033 4.07502 1.28749 4.07502 1.43749V1.89999H7.92502V1.43749C7.92502 1.28749 7.97719 1.16033 8.08152 1.05599C8.18552 0.951994 8.31252 0.899994 8.46252 0.899994C8.61252 0.899994 8.73969 0.951994 8.84402 1.05599C8.94802 1.16033 9.00002 1.28749 9.00002 1.43749V1.89999H9.46252C9.77919 1.89999 10.048 2.01033 10.269 2.23099C10.4897 2.45199 10.6 2.72083 10.6 3.03749V6.01249H9.46252V4.99999H2.53752V9.96249H5.87502V11.1H2.53752ZM2.53752 3.99999H9.46252V3.03749H2.53752V3.99999ZM9.50002 12.125C9.02502 12.125 8.59386 12.0063 8.20652 11.769C7.81886 11.5313 7.52502 11.2208 7.32502 10.8375C7.22502 10.6875 7.21036 10.5355 7.28102 10.3815C7.35202 10.2272 7.48752 10.15 7.68752 10.15C7.76252 10.15 7.83552 10.1708 7.90652 10.2125C7.97719 10.2542 8.03336 10.3042 8.07502 10.3625C8.20836 10.6208 8.40002 10.8313 8.65002 10.994C8.90002 11.1563 9.18336 11.2375 9.50002 11.2375C9.95836 11.2375 10.3522 11.075 10.6815 10.75C11.0105 10.425 11.175 10.0333 11.175 9.57499C11.175 9.10833 11.0125 8.71249 10.6875 8.38749C10.3625 8.06249 9.96669 7.89999 9.50002 7.89999C9.27502 7.89999 9.06669 7.93749 8.87502 8.01249C8.68336 8.08749 8.51669 8.19583 8.37502 8.33749H8.66252C8.77919 8.34583 8.87302 8.39166 8.94402 8.47499C9.01469 8.55833 9.05002 8.66249 9.05002 8.78749C9.05002 8.91249 9.00836 9.01666 8.92502 9.09999C8.84169 9.18333 8.73752 9.22499 8.61252 9.22499H7.43752C7.27919 9.22499 7.14586 9.17083 7.03752 9.06249C6.92919 8.95416 6.87502 8.82083 6.87502 8.66249V7.48749C6.87502 7.36249 6.91669 7.25833 7.00002 7.17499C7.08336 7.09166 7.18752 7.04999 7.31252 7.04999C7.43752 7.04999 7.53969 7.08333 7.61902 7.14999C7.69802 7.21666 7.74586 7.30833 7.76252 7.42499V7.69999C7.98752 7.49166 8.24786 7.32499 8.54352 7.19999C8.83952 7.07499 9.15836 7.01249 9.50002 7.01249C10.2084 7.01249 10.8125 7.26033 11.3125 7.75599C11.8125 8.25199 12.0625 8.85416 12.0625 9.56249C12.0625 10.2708 11.8125 10.875 11.3125 11.375C10.8125 11.875 10.2084 12.125 9.50002 12.125Z'
																fill='#FF5334'
															/>
														</g>
													</g>
													<defs>
														<clipPath id='clip0_491_128728'>
															<rect width='12' height='12' fill='white' />
														</clipPath>
													</defs>
												</svg>
												<div className='error-hover-state'>
													<p>No History</p>
													<svg
														width='17'
														height='8'
														viewBox='0 0 17 8'
														fill='none'
														xmlns='http://www.w3.org/2000/svg'
													>
														<path
															d='M8.86632 7.40838C8.83899 7.43528 8.71392 7.5 8.5 7.5C8.28608 7.5 8.16101 7.43528 8.13369 7.40838L1.13583 0.519758C1.19042 0.507766 1.25531 0.500001 1.32924 0.500001L15.6708 0.5C15.7447 0.5 15.8096 0.507766 15.8642 0.519757L8.86632 7.40838Z'
															fill='#FF5334'
															stroke='#FF5334'
															strokeMiterlimit='1.78922'
														/>
													</svg>
												</div>
											</div>
										</>
									)}
								</div>
							<p>
							Uplift (Unit.) <br /> <span>{uplift}</span>
							</p>
						</div>
						<div style={{borderColor: fontColor}}>
							<p>
								Uplift (%) <br /> <span>{upliftPorcentual}</span>
							</p>
						</div>
						<div style={{borderColor: fontColor}}>
							<p>
								Promotional Mg. <br /> <span>{margenComercial}</span>
							</p>
						</div>
						<div style={{borderColor: fontColor}}>
							
							<p>
								
								ROI <br /> <span>{roi}</span>
							</p>
							 
							{ /* <p>
								
								Mg. Comercial Incr. <br /> <span>{margenComercialIncremental}</span>
							</p> */ }
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
